import React, { PureComponent } from 'react'
import SessionConnector from 'containers/Session'
import FollowConnect from 'containers/Follow'
import { Actions as FollowActions } from 'actions/user/follow'
import NavigationLayout from 'layouts/Navigation'
import TrendingArtists from '../components/TrendingArtists'

// Get follows if user is authenticated
const runFollowAction = async (
  dispatch: (...args: Array<any>) => any,
  isAuthenticated: boolean
) => {
  if (isAuthenticated) {
    dispatch(FollowActions.FETCH())
  }
}

type Props = Record<string, any>

class TA extends PureComponent<Props> {
  componentDidMount() {
    runFollowAction(this.props.dispatch, this.props.session.isAuthenticated)
  }

  render() {
    return (
      <NavigationLayout>
        <TrendingArtists />
      </NavigationLayout>
    )
  }
}

export default SessionConnector(FollowConnect(TA))